import { render, staticRenderFns } from "./studySituation.vue?vue&type=template&id=a1601bfe&scoped=true"
import script from "./studySituation.vue?vue&type=script&lang=js"
export * from "./studySituation.vue?vue&type=script&lang=js"
import style0 from "./studySituation.vue?vue&type=style&index=0&id=a1601bfe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1601bfe",
  null
  
)

export default component.exports